import { Controller } from "@hotwired/stimulus"

// Handles mobile sidebar menu toggle and animations
export default class extends Controller {
  static targets = ["menu", "overlay", "panel"]

  connect() {
    console.log("Mobile menu controller connected")
    console.log("Targets:", {
      hasMenu: this.hasMenuTarget,
      hasOverlay: this.hasOverlayTarget,
      hasPanel: this.hasPanelTarget
    })
    // Ensure menu is hidden on connect - but don't use close() which sets a timeout
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")
    }
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("opacity-0")
      this.overlayTarget.classList.remove("opacity-100")
    }
    if (this.hasPanelTarget) {
      this.panelTarget.classList.add("-translate-x-full")
      this.panelTarget.classList.remove("translate-x-0")
    }
  }

  // Opens the mobile menu with animation
  open() {
    console.log("Opening mobile menu")

    // Show menu container first
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove("hidden")

      // Trigger animations after a frame
      requestAnimationFrame(() => {
        // Show overlay with fade in
        if (this.hasOverlayTarget) {
          this.overlayTarget.classList.remove("opacity-0")
          this.overlayTarget.classList.add("opacity-100")
        }

        // Slide in the panel
        if (this.hasPanelTarget) {
          this.panelTarget.classList.remove("-translate-x-full")
          this.panelTarget.classList.add("translate-x-0")
        }
      })
    }

    // Prevent body scroll when menu is open
    document.body.style.overflow = 'hidden'
  }

  // Closes the mobile menu with animation
  close() {
    console.log("Closing mobile menu")

    // Fade out overlay
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("opacity-100")
      this.overlayTarget.classList.add("opacity-0")
    }

    // Slide out panel
    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove("translate-x-0")
      this.panelTarget.classList.add("-translate-x-full")
    }

    // Hide container after animation
    if (this.hasMenuTarget) {
      setTimeout(() => {
        this.menuTarget.classList.add("hidden")
      }, 300)
    }

    // Restore body scroll
    document.body.style.overflow = ''
  }

  // Toggle menu state
  toggle() {
    if (this.hasMenuTarget && this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }

  // Close menu when clicking overlay
  closeOnOverlay(event) {
    // Only close if clicking the overlay itself, not its children
    if (event.target === event.currentTarget) {
      this.close()
    }
  }

  // Close menu when navigating (Turbo)
  disconnect() {
    // Restore body scroll if menu was open
    document.body.style.overflow = ''
  }
}